export const PURCHASER_OWNER_DATA_REQUEST = 'PURCHASER_OWNER_DATA_REQUEST';
export const PURCHASER_OWNER_DATA_SUCCESS = 'PURCHASER_OWNER_DATA_SUCCESS';
export const PURCHASER_OWNER_DATA_FAIL = 'PURCHASER_OWNER_DATA_FAIL';
